import { useRef } from "react";
import useImagesLoaded from "../../hooks/useImagesLoaded";
import DesignHero from "../../components/Design/Airframe/DesignHero";
import DesignCapabilities from "../../components/Design/Airframe/DesignCapabilities";
import DesignStatement from "../../components/Design/Airframe/DesignStatement";

export default function DesignPage() {

    const containerRef = useRef(null);
    useImagesLoaded(containerRef);

    return (
        <main ref={containerRef}>
            <DesignHero />
            <DesignCapabilities />
            <DesignStatement />

        </main>
    );
}